import $ from 'jquery';

$(document).ready(function modalFloorPlan() {

    $('.floorplan-modal').on('show.bs.modal', function (event) {
        var modalFloorPlanString;
        var floorPlanTitle = $(event.relatedTarget).attr('data-floorplan-title');
        var floorPlanPDfUrl = $(event.relatedTarget).attr('data-floorplan-pdf-href');
        var floorPlanImageSource = $(event.relatedTarget).attr('data-floorplan-image-src');
        var floorPlanDownloadText = $(event.relatedTarget).attr('data-floorplan-download-text');

        var modal = $(event.currentTarget);

        if (floorPlanTitle, floorPlanPDfUrl, floorPlanImageSource) {
            modalFloorPlanString = '<div class="modal-header">' +
                '<h5 class="modal-title detail" id="floorPlanDownload">' +
            floorPlanTitle +
                '</h5 > ' +
                '<a class="btn btn-primary" href="' +
            floorPlanPDfUrl +
            '" target="_blank">' +
                floorPlanDownloadText +
                '</a>' +
                '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                '</div>' +
                '<div class="modal-body">' +
                '<figure>' +
                '<img src="' +
                floorPlanImageSource +
                '" alt="Floor Plan view">' +
                '</figure>' +
                '</div>';

            modal.find('.modal-content').html(modalFloorPlanString);
        }
    });

});